export default Object.freeze({
  timeUnits: {
    week: 'week',
    day: 'day',
    hour: 'hour',
    minute: 'minute',
  },
})
